import { FC, PropsWithChildren, createContext } from 'react'
import { QueryClient } from '@tanstack/query-core'

import { AuthService } from 'lib/auth'
import { queryClient } from 'lib/queryClient'

export interface IAppProvider {
  authService: AuthService
  queryClient: QueryClient
}

const appProvider: IAppProvider = {
  authService: new AuthService(),
  queryClient,
}

export const AppContext = createContext<IAppProvider>(appProvider)

export const AppProvider: FC<PropsWithChildren> = props => {
  return <AppContext.Provider value={appProvider}>{props.children}</AppContext.Provider>
}
